import { CaretDownIcon } from 'app/common/presentation/icons'
import { Workspace } from 'app/user/types'

import styles from './Profile.module.scss'

interface ProfileButtonProps {
  workspace: Workspace
  onClick: () => void
}

const ProfileButton = ({ workspace, onClick }: ProfileButtonProps) => (
  <button className={styles.profileButton} onClick={onClick} type="button">
    <div className={styles.workspaceIcon}>{workspace.name.slice(0, 1).toUpperCase()}</div>
    <div className={styles.workspace}>{workspace.name}</div>
    <CaretDownIcon className={styles.caret} />
  </button>
)

export default ProfileButton
